import { SearchOutlined } from '@ant-design/icons';
import { Button, Col, DatePicker, DatePickerProps, Input, Row, Table, Tag } from "antd";
import Column from 'antd/es/table/Column';
import dayjs, { Dayjs } from 'dayjs';
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import { ContentHeader } from "../../components";
import { searchLength } from '../../constants';
import { Links } from "../../helpers/Links";
import { menuHelper } from "../../helpers/account";
import { dateCommon } from '../../helpers/common';
import { TimKiemDonNgoaiGioPagingResponse } from '../../models/ngoaigio/DonNgoaiGio';
import { timKiemDonNgoaiGio } from '../../services/ngoaigio';

const PheDuyetThemGio = () => {
    const [isLoadingTable, setIsLoadingTable] = useState<boolean>(false);
    const menu: any = menuHelper.checkMultiPermission([Links.NgoaiGio.PheDuyet]);
    const [namValue, setNamValue] = useState<Dayjs | null>(dayjs());
    const namFormat: DatePickerProps['format'] = (value) => `Năm ${value.format('YYYY')}`;
    const [reloadPage, setReloadPage] = useState<boolean>(true);
    const [tuKhoa, setTuKhoa] = useState<string>("");
    const [nam, setNam] = useState<string>(new Date().getFullYear().toString());
    const [page, setPage] = useState(1);
    
    const [danhSach, setDanhSach] = useState<TimKiemDonNgoaiGioPagingResponse>({
        "data": [],
        "recordsTotal": 0,
        "maxPage": 0,
        "pageCurrent": 0,
        "pageListShow": [0]
    });

    const timkiem = async (tuKhoa: string, nam: string, start: number, length: number, page: number) => {
        try {
            setPage(1);
            setIsLoadingTable(true);
            const temp = await timKiemDonNgoaiGio(tuKhoa, nam, start, length);
            const maxPage = temp?.recordsTotal === 0 ? 0 : (parseInt((temp?.recordsTotal / searchLength).toString()) + (temp?.recordsTotal % searchLength ? 0 : -1)) || 0;
            setDanhSach({
                "data": (temp?.data || []).map((item: any) => { item.key = item.id; return item }),
                "recordsTotal": temp?.recordsTotal || 0,
                "maxPage": maxPage,
                "pageCurrent": page,
                "pageListShow": []
            });
            setIsLoadingTable(false);
        }
        catch (error: any) {
            toast.error(error);
            setIsLoadingTable(false);
        };
    }

    const onChange: DatePickerProps['onChange'] = (year) => {
        var yearStr = year?.format('YYYY');
        setNamValue(year);
        if (yearStr) {
            setNam(yearStr);
            timkiem(tuKhoa, yearStr, 0, 0, 0);
        } else {
            setNam("");
            timkiem(tuKhoa, "", 0, 0, 0);
        }
    }

    const handleKeyPress = (event: React.KeyboardEvent<HTMLInputElement>) => {
        if (event.key === 'Enter') {
            timkiem(tuKhoa, nam, 0, 0, 0)
        }
    };

    useEffect(() => {
        if (reloadPage) {
            setDanhSach({
                "data": [],
                "recordsTotal": 0,
                "maxPage": 0,
                "pageCurrent": 0,
                "pageListShow": [0]
            });
            timkiem(tuKhoa, nam, 0, 0, 0);
            setReloadPage(false);
        }
    }, [reloadPage]);
    return (
        <section>
            <ContentHeader title="Phê duyệt thêm giờ" />
            <Row gutter={8} className="form-group">
                <Col span={4}>
                    <DatePicker changeOnBlur={true} value={namValue} style={{ width: "100%" }} placeholder="Năm" picker="year" format={namFormat} onChange={onChange} />
                </Col>
                <Col span={8}>
                    <Input prefix={<SearchOutlined rev="" />} placeholder="Nhập tên nhân viên, tên phòng ban tên người duyệt, tên người ý kiến" onChange={(e) => setTuKhoa(e.target.value)}
                        onKeyPress={handleKeyPress} />
                </Col>
                <Col span={4}>
                    <Button type="primary" icon={<SearchOutlined rev="" />} onClick={() => timkiem(tuKhoa, nam, 0, 0, 0)}>
                        Tìm kiếm
                    </Button>
                </Col>
            </Row>
            <Row>
                <Col span="24">
                    <div className="card card-primary">
                        <Table
                            dataSource={danhSach.data || []}
                            loading={isLoadingTable}
                            locale={{ emptyText: "Không có dữ liệu" }}
                            pagination={{
                                current: page,
                                onChange: (page, pageSize) => {
                                    setPage(page);
                                },
                            }}
                        >
                            <Column title="STT" key="STT" width="5%" render={(value, record, index) =>
                                (<span key={"stt" + index}> {(page - 1) * searchLength + index + 1}</span>)
                            } />
                            <Column title="Nhân viên" dataIndex="tenNhanVien" key="tenNhanVien" />
                            <Column title="Phòng ban" dataIndex="tenDonVi" key="tenDonVi" />
                            <Column title="Trạng thái" width="15%" dataIndex="trangThai" key="trangThai" render={(value, record) => {
                                var tag = (<Tag color="default"></Tag>);
                                switch (value) {
                                    case 0: tag = (<Tag color="processing">Khởi tạo</Tag>); break;
                                    case 1: tag = (<Tag color="warning">Trình Lãnh đạo</Tag>); break;
                                    case 2: tag = (<Tag color="success">Đã Duyệt</Tag>); break;
                                    case 3: tag = (<Tag color="error">Từ chối</Tag>); break;
                                    case 4: tag = (<Tag color="error">Lấy ý kiến</Tag>); break;
                                }
                                return tag;
                            }} />
                            <Column title="Người ý kiến" dataIndex="tenNguoiYKien" key="tenNguoiYKien" />
                            <Column title="Người duyệt" dataIndex="tenNguoiDuyet" key="tenNguoiDuyet" />
                            <Column title="Ngày" dataIndex="ngay" key="ngay" render={(value: any, record: any) => {
                                return dateCommon.formatDate(value, "dd/MM/yyyy");
                            }} />
                            <Column title="Số giờ" dataIndex="soGio" key="soGio" />
                            <Column title="" dataIndex="action" key="action" render={(value: any, record: any) => {
                                return menu[Links.NgoaiGio.PheDuyet]
                                    ? (<Link className="hrm-btn hrm-btn-sm btn-primary" to={Links.NgoaiGio.Xem + "?id=" + record.id}>Xem</Link>)
                                    : "";
                            }} />
                        </Table>
                    </div>
                </Col>
            </Row>
        </section>
    );
};

export default PheDuyetThemGio;